import Component from '../core/Component';

export default class Unfold extends Component {
    constructor($element) {
        super($element)
        this.originalText = this.$element.text()
    }

    prepare() {
        this.$element.on('click', event => {
            event.preventDefault()
            if ($(this.$element.attr('href')).css('display') == 'none') {
                this.$element.css('opacity','0')
                $(this.$element.attr('href')).slideDown()
            } else {
                $(this.$element.attr('href')).slideUp()
            }
        })

    }
}



// WEBPACK FOOTER //
// ./components/Unfold.js